import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import './_styles_/EnvTitle.css';
import { getPublicConfig } from '../reducers';
import { joinClassNames } from '../utils';

EnvTitle.propTypes = {
    className: PropTypes.string,
};

EnvTitle.defaultProps = {
    className: null,
};

function EnvTitle(props) {
    const {
        className,
    } = props;
    const publicConfig = useSelector(getPublicConfig);
    if (publicConfig.envTitle && publicConfig.envTitle !== 'PROD') {
        return (
            <div className={joinClassNames('env-title', className)}>
                {publicConfig.envTitle}
            </div>
        );
    }

    return null;
}

export default EnvTitle;
